// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"-all-wrapper-2uPkVB-","admin-card":"-all-admin-card-1q6A_g-","admin-table":"-all-admin-table-1lhGUV-","admin-table-th":"-all-admin-table-th-QvL1oG-","admin-table-action":"-all-admin-table-action-2BOfDK-","admin-button":"-all-admin-button-1mFHbJ-","admin-input":"-all-admin-input-QSxUav-","admin-table-icon-cell":"-all-admin-table-icon-cell-2f3_wS-"};


//////////////////
// WEBPACK FOOTER
// ./src/views/admin/all.css
// module id = 162
// module chunks = 0